import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import "../../css/AddStudents.css";
import Loader from "../../components/Loader"
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function AddStudents() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    dob: '',
    gender: '',
    address: '',
    parentName: '',
    parentPhone: '',
    grade: '',
    section: '',
    admissionDate: '',
    rollNumber: '',
    bloodGroup: '',
  });
  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('individual');
  const [file, setFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [uploadedStudents, setUploadedStudents] = useState([]);

  useEffect(() => {
    fetchClasses();
  }, []);




  const fetchClasses = async () => {
    setLoading(true);
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Unauthorized! Please login again.");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch("https://schoolpro-api.uniums.com/api/classes", {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        // Process and remove duplicates from classes
        const uniqueClasses = [...new Set(data.map(cls => cls.name))];
        setClasses(uniqueClasses);
      } else {
        toast.error("Failed to fetch classes");
      }
    } catch (error) {
      console.error("Error fetching classes:", error);
      toast.error("Error loading classes data");
    } finally {
      setLoading(false);
    }
  };

  const handleGradeChange = (e) => {
    const selectedGrade = e.target.value;
    handleInputChange(e);

    if (selectedGrade) {
      // Filter sections for the selected grade
      const gradeSections = classes.length > 0 ?
        [...new Set(classes
          .filter(cls => cls.name === selectedGrade)
          .map(cls => cls.section))] :
        [];

      setSections(gradeSections);
    } else {
      setSections([]);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Unauthorized! Please login in again.");
      return;
    }
    setIsUploading(true);
    try {
      const response = await fetch("https://schoolpro-api.uniums.com/api/students/add", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      if (response.ok) {
        toast.success("Student Added Successfully");
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          dob: '',
          gender: '',
          address: '',
          parentName: '',
          parentPhone: '',
          grade: '',
          section: '',
          admissionDate: '',
          rollNumber: '',
          bloodGroup: '',
        });
      } else {
        toast.error(data.message || "Failed to add student");
      }
    } catch (error) {
      console.error("Error submitting student data:", error);
      toast.error("An error occurred shile submitting the data");
    } finally {
      setIsUploading(false);
    }
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setUploadedStudents([]);
    setUploadSuccess(false);
  };

  const handleFileUpload = async (e) => {
    e.preventDefault();
    if (!file) {
      toast.error('Please select a file first!');
      return;
    }

    setIsUploading(true);
    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const worksheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[worksheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        const headers = jsonData[0];
        const headerMapping = {
          'first name': 'firstName',
          'last name': 'lastName',
          'firstname': 'firstName',
          'lastname': 'lastName',
          'first': 'firstName',
          'last': 'lastName',
          'date of birth': 'dob',
          'dateofbirth': 'dob',
          'date': 'dob',
          'gender': 'gender',
          'email': 'email',
          'phone': 'phone',
          'address': 'address',
          'parent name': 'parentName',
          'parentname': 'parentName',
          'parent/guardian name': 'parentName',
          'parentguardianname': 'parentName',
          'parent': 'parentName',
          'parent phone': 'parentPhone',
          'parentphone': 'parentPhone',
          'parent/guardian phone': 'parentPhone',
          'parentguardianphone': 'parentPhone',
          'grade/class': 'grade',
          'grade': 'grade',
          'gradeclass': 'grade',
          'class': 'grade',
          'section': 'section',
          'roll number': 'rollNumber',
          'rollnumber': 'rollNumber',
          'roll': 'rollNumber',
          'admission date': 'admissionDate',
          'admissiondate': 'admissionDate',
          'blood group': 'bloodGroup',
          'bloodgroup': 'bloodGroup',
          'blood': 'bloodGroup'
        };

        const students = [];
        const errors = [];

        for (let i = 1; i < jsonData.length; i++) {
          const row = jsonData[i];
          // Skip empty rows
          if (row.length === 0 || row.every(cell => cell === "")) continue;

          const student = {};
          let hasError = false;

          headers.forEach((header, index) => {
            if (!header) return;

            const cleanHeader = header
              .replace(/\*/g, '')
              .replace(/\([^)]*\)/g, '')
              .trim()
              .toLowerCase();

            const schemaProperty = headerMapping[cleanHeader] || cleanHeader;
            if (!headerMapping[cleanHeader] && !row[index]) return;

            student[schemaProperty] = row[index] || '';
          });
          if (student.dob) {
            student.dob = new Date(student.dob).toISOString().split('T')[0];
            if (isNaN(new Date(student.dob).getTime())) {
              errors.push(`Row ${i + 1}: Invalid date of birth format. Expected YYYY-MM-DD`);
              hasError = true;
            }
          } else {
            errors.push(`Row ${i + 1}: Missing required field: Date of Birth`);
            hasError = true;
          }

          if (student.admissionDate) {
            student.admissionDate = new Date(student.admissionDate).toISOString().split('T')[0];
            if (isNaN(new Date(student.admissionDate).getTime())) {
              errors.push(`Row ${i + 1}: Invalid admission date format. Expected YYYY-MM-DD`);
              hasError = true;
            }
          } else {
            errors.push(`Row ${i + 1}: Missing required field: Admission Date`);
            hasError = true;
          }
          if (student.grade) {
            student.grade = student.grade.toString().trim();
            if (!student.grade) {
              errors.push(`Row ${i + 1}: Grade cannot be empty`);
              hasError = true;
            }
          } else {
            errors.push(`Row ${i + 1}: Missing required field: Grade`);
            hasError = true;
          }

          const requiredFields = [
            { field: 'firstName', label: 'First Name' },
            { field: 'lastName', label: 'Last Name' },
            { field: 'email', label: 'Email' },
            { field: 'phone', label: 'Phone' },
            { field: 'gender', label: 'Gender' },
            { field: 'address', label: 'Address' },
            { field: 'parentName', label: 'Parent Name' },
            { field: 'parentPhone', label: 'Parent Phone' },
            { field: 'section', label: 'Section' },
            { field: 'rollNumber', label: 'Roll Number' }
          ];

          requiredFields.forEach(({ field, label }) => {
            if (!student[field]) {
              errors.push(`Row ${i + 1}: Missing required field: ${label}`);
              hasError = true;
            }
          });

          if (student.gender) {
            student.gender = student.gender.toLowerCase();
            if (!['male', 'female', 'other'].includes(student.gender)) {
              errors.push(`Row ${i + 1}: Invalid gender value. Must be Male, Female, or Other`);
              hasError = true;
            }
          }

          const validBloodGroups = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'];
          if (student.bloodGroup && !validBloodGroups.includes(student.bloodGroup)) {
            errors.push(`Row ${i + 1}: Invalid blood group. Must be one of ${validBloodGroups.join(', ')}`);
            hasError = true;
          }

          if (!hasError) {
            students.push(student);
          }
        }

        if (errors.length > 0) {
          const errorMessage = `Found ${errors.length} errors in the data:\n${errors.slice(0, 5).join('\n')}${errors.length > 5 ? `\n...and ${errors.length - 5} more errors` : ''}`;
          console.error('Validation errors prevented upload:', errorMessage);
          toast.error(errorMessage);
          setIsUploading(false);
          return;
        }

        if (students.length === 0) {
          console.error('No valid students found after validation');
          toast.error('No valid student data found in the file.');
          setIsUploading(false);
          return;
        }

        const token = localStorage.getItem("token");
        if (!token) {
          toast.error("Unauthorized! Please login again.");
          setIsUploading(false);
          return;
        }

        try {
          const response = await fetch("https://schoolpro-api.uniums.com/api/students/bulk", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify(students),
          });

          const result = await response.json();
          if (response.ok) {
            setUploadedStudents(students);
            setUploadSuccess(true);
            toast.success(`Successfully added ${students.length} students to the database.`);
          } else {
            toast.error(result.message || "Failed to add students");
            setUploadSuccess(false);
          }
        } catch (error) {
          console.error('Error uploading students to backend:', error);
          toast.error(`Error uploading students: ${error.message}`);
          setUploadSuccess(false);
        }

      } catch (error) {
        console.error('Error processing file:', error);
        toast.error(`Error processing file: ${error.message}`);
        setUploadSuccess(false);
      } finally {
        setIsUploading(false);
      }
    };

    reader.onerror = (error) => {
      console.error('FileReader error:', error);
      toast.error('Error reading file');
      setIsUploading(false);
      setUploadSuccess(false);
    };

    reader.readAsArrayBuffer(file);
  };
  const downloadTemplate = () => {
    try {
      const headers = [
        "First Name*",
        "Last Name*",
        "Date of Birth* (YYYY-MM-DD)",
        "Gender* (Male/Female/Other)",
        "Email*",
        "Phone*",
        "Address*",
        "Parent Name*",
        "Parent Phone*",
        "Grade/Class* (e.g., " + (classes.length > 0 ? classes.join(", ") : "Grade 1, 11th, 12th") + ")",
        "Section* (e.g., " + (classes.length > 0 ? [...new Set(classes.map(cls => cls.section))].join(", ") : "A/B/C/D") + ")",
        "Roll Number*",
        "Admission Date* (YYYY-MM-DD)",
        "Blood Group"
      ];

      const sampleRow = [
        "John",
        "Doe",
        "2010-05-15",
        "Male",
        "john.doe@example.com",
        "1234567890",
        "123 School Street, City",
        "Jane Doe",
        "0987654321",
        "8",
        "B",
        "R12345",
        "2023-06-15",
        "O+"
      ];

      const sampleRow2 = [
        "Mary",
        "Smith",
        "2011-08-22",
        "Female",
        "mary.smith@example.com",
        "2345678901",
        "456 Academy Road, City",
        "Robert Smith",
        "1234509876",
        "7",
        "A",
        "R12346",
        "2023-06-16",
        "A+"
      ];
      const ws = XLSX.utils.aoa_to_sheet([
        headers,
        sampleRow,
        sampleRow2,
        Array(headers.length).fill("")
      ]);
      const colWidths = headers.map(h => ({ wch: Math.max(h.length, 15) }));
      ws['!cols'] = colWidths;

      ws.A5 = {
        v: "INSTRUCTIONS: Fill in the student details starting from row 4. Fields marked with * are required. Please maintain the date format as YYYY-MM-DD.",
        t: 's'
      };
      ws.A6 = {
        v: "You can delete the sample rows (2-3) before importing the file.",
        t: 's'
      };
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Student Template");
      XLSX.writeFile(wb, "Student_Data_Template.xlsx");
    } catch (error) {
      console.error("Error generating Excel template:", error);
      toast.error("Failed to generate Excel template. Please try again.");
    }
  };

  return (
    <>
      <div className="addstudent-container">
        <h1 className="addstudent-title">Add Students</h1>
        {isUploading && <Loader />}
        <div className="addstudent-tabs">
          <button
            className={`addstudent-tab ${activeTab === 'individual' ? 'addstudent-tab-active' : ''}`}
            onClick={() => setActiveTab('individual')}
          >
            Add Individual Student
          </button>
          <button
            className={`addstudent-tab ${activeTab === 'bulk' ? 'addstudent-tab-active' : ''}`}
            onClick={() => setActiveTab('bulk')}
          >
            Bulk Upload
          </button>
        </div>

        {activeTab === 'individual' ? (
          <div className="addstudent-form-container">
            <form onSubmit={handleSubmit} className="addstudent-form">
              <div className="addstudent-form-section">
                <h2 className="addstudent-section-title">Personal Information</h2>
                <div className="addstudent-form-row">
                  <div className="addstudent-form-group">
                    <label className="addstudent-label">First Name*</label>
                    <input
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleInputChange}
                      className="addstudent-input"
                      required
                    />
                  </div>
                  <div className="addstudent-form-group">
                    <label className="addstudent-label">Last Name*</label>
                    <input
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleInputChange}
                      className="addstudent-input"
                      required
                    />
                  </div>
                </div>

                <div className="addstudent-form-row">
                  <div className="addstudent-form-group">
                    <label className="addstudent-label">Date of Birth*</label>
                    <input
                      type="date"
                      name="dob"
                      value={formData.dob}
                      onChange={handleInputChange}
                      className="addstudent-input"
                      required
                    />
                  </div>
                  <div className="addstudent-form-group">
                    <label className="addstudent-label">Gender*</label>
                    <select
                      name="gender"
                      value={formData.gender}
                      onChange={handleInputChange}
                      className="addstudent-select"
                      required
                    >
                      <option value="">Select Gender</option>
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>

                <div className="addstudent-form-row">
                  <div className="addstudent-form-group">
                    <label className="addstudent-label">Email*</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className="addstudent-input"
                      required
                    />
                  </div>
                  <div className="addstudent-form-group">
                    <label className="addstudent-label">Phone*</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      className="addstudent-input"
                      required
                    />
                  </div>
                </div>

                <div className="addstudent-form-group">
                  <label className="addstudent-label">Address*</label>
                  <textarea
                    name="address"
                    value={formData.address}
                    onChange={handleInputChange}
                    className="addstudent-textarea"
                    required
                  ></textarea>
                </div>
              </div>

              <div className="addstudent-form-section">
                <h2 className="addstudent-section-title">Parent/Guardian Information</h2>
                <div className="addstudent-form-row">
                  <div className="addstudent-form-group">
                    <label className="addstudent-label">Parent/Guardian Name*</label>
                    <input
                      type="text"
                      name="parentName"
                      value={formData.parentName}
                      onChange={handleInputChange}
                      className="addstudent-input"
                      required
                    />
                  </div>
                  <div className="addstudent-form-group">
                    <label className="addstudent-label">Parent/Guardian Phone*</label>
                    <input
                      type="tel"
                      name="parentPhone"
                      value={formData.parentPhone}
                      onChange={handleInputChange}
                      className="addstudent-input"
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="addstudent-form-section">
                <h2 className="addstudent-section-title">Academic Information</h2>
                <div className="addstudent-form-row">
                  <div className="addstudent-form-group">
                    <label className="addstudent-label">Grade/Class*</label>
                    <select
                      name="grade"
                      value={formData.grade}
                      onChange={handleGradeChange}
                      className="addstudent-select"
                      required
                    >
                      <option value="">Select Grade</option>
                      {classes.length > 0 ? (
                        classes.map((className, index) => (
                          <option key={index} value={className}>{className}</option>
                        ))
                      ) : (
                        <>
                          <option value="Grade 1">Grade 1</option>
                          <option value="Grade 2">Grade 2</option>
                          <option value="Grade 3">Grade 3</option>
                          <option value="Grade 4">Grade 4</option>
                          <option value="Grade 5">Grade 5</option>
                          <option value="Grade 6">Grade 6</option>
                          <option value="Grade 7">Grade 7</option>
                          <option value="Grade 8">Grade 8</option>
                          <option value="Grade 9">Grade 9</option>
                          <option value="Grade 10">Grade 10</option>
                          <option value="Grade 11">Grade 11</option>
                          <option value="Grade 12">Grade 12</option>
                        </>
                      )}
                    </select>
                  </div>
                  <div className="addstudent-form-group">
                    <label className="addstudent-label">Section*</label>
                    <select
                      name="section"
                      value={formData.section}
                      onChange={handleInputChange}
                      className="addstudent-select"
                      required
                    >
                      <option value="">Select Section</option>
                      {sections.length > 0 ? (
                        sections.map((section, index) => (
                          <option key={index} value={section}>{section}</option>
                        ))
                      ) : (
                        // Fallback options if no sections are loaded
                        <>
                          <option value="A">A</option>
                          <option value="B">B</option>
                          <option value="C">C</option>
                          <option value="D">D</option>
                        </>
                      )}
                    </select>
                  </div>
                </div>

                <div className="addstudent-form-row">
                  <div className="addstudent-form-group">
                    <label className="addstudent-label">Roll Number*</label>
                    <input
                      type="text"
                      name="rollNumber"
                      value={formData.rollNumber}
                      onChange={handleInputChange}
                      className="addstudent-input"
                      required
                    />
                  </div>
                  <div className="addstudent-form-group">
                    <label className="addstudent-label">Admission Date*</label>
                    <input
                      type="date"
                      name="admissionDate"
                      value={formData.admissionDate}
                      onChange={handleInputChange}
                      className="addstudent-input"
                      required
                    />
                  </div>
                </div>

                <div className="addstudent-form-row">
                  <div className="addstudent-form-group">
                    <label className="addstudent-label">Blood Group</label>
                    <select
                      name="bloodGroup"
                      value={formData.bloodGroup}
                      onChange={handleInputChange}
                      className="addstudent-select"
                    >
                      <option value="">Select Blood Group</option>
                      <option value="A+">A+</option>
                      <option value="A-">A-</option>
                      <option value="B+">B+</option>
                      <option value="B-">B-</option>
                      <option value="AB+">AB+</option>
                      <option value="AB-">AB-</option>
                      <option value="O+">O+</option>
                      <option value="O-">O-</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="addstudent-button-container">
                <button type="submit" className="addstudent-submit-btn">Add Student</button>
                <button type="reset" className="addstudent-reset-btn">Reset Form</button>
              </div>
            </form>
          </div>
        ) : (
          <div className="addstudent-bulk-container">
            <div className="addstudent-bulk-instructions">
              <h2 className="addstudent-section-title">Bulk Upload Instructions</h2>
              <ol className="addstudent-instruction-list">
                <li>Download the Excel template using the button below</li>
                <li>Fill in the required student information in the template</li>
                <li>Save the file and upload it using the form below</li>
                <li>Review any errors that may occur during upload</li>
              </ol>
              <button
                className="addstudent-download-btn"
                onClick={downloadTemplate}
              >
                Download Excel Template
              </button>
            </div>

            <div className="addstudent-upload-container">
              <h2 className="addstudent-section-title">Upload Excel File</h2>
              <form onSubmit={handleFileUpload} className="addstudent-upload-form">
                <div className="addstudent-file-input-container">
                  <input
                    type="file"
                    accept=".xlsx, .xls, .csv"
                    onChange={handleFileChange}
                    className="addstudent-file-input"
                    id="file-upload"
                  />
                  <label htmlFor="file-upload" className="addstudent-file-label">
                    {file ? file.name : 'Choose File'}
                  </label>
                </div>

                <button
                  type="submit"
                  className="addstudent-upload-btn"
                  disabled={isUploading}
                >
                  {isUploading ? 'Uploading...' : 'Upload File'}
                </button>
              </form>

              {uploadSuccess && (
                <div className="addstudent-success-message">
                  File uploaded successfully! {uploadedStudents.length} students have been added to the system.
                </div>
              )}

              {uploadSuccess && uploadedStudents.length > 0 && (
                <div className="addstudent-upload-summary">
                  <h3 className="addstudent-summary-title">Upload Summary</h3>
                  <div className="addstudent-summary-content">
                    <p><strong>Total Students:</strong> {uploadedStudents.length}</p>
                    <p><strong>Processed:</strong> {uploadedStudents.length}</p>
                    <p><strong>Status:</strong> Ready to be added to database</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <ToastContainer />
    </>

  );
}

export default AddStudents;